import { createContext, useContext } from 'react';
import { RIGHT_ALIGNED } from '../visitor-widget/constants/WidgetLocations';
const defaultWidgetResizeContextValue = {
  isResizeEnabled: false,
  onResizeHandlePointerDown: () => {},
  widgetLocation: RIGHT_ALIGNED,
  isResizing: false,
  isExpanded: false,
  onToggleExpand: () => {}
};
export const WidgetResizeContext = /*#__PURE__*/createContext(defaultWidgetResizeContextValue);
export const useWidgetResizeContext = () => useContext(WidgetResizeContext);